<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="cont" epub:type="toc" role="doc-toc">
<header>
<h1 class="chtitlea" id="cont"><span aria-label=" Page vii. " epub:type="pagebreak" id="pg_vii" role="doc-pagebreak"><span class="borb"><samp>Contents</samp></span></span></h1>
</header>
<ol class="toc-list">
<li class="toc1"><a href="#/xhtml/introduction"><b><samp>Introduction</samp></b></a></li>
<li class="toc1"><a href="#/xhtml/part1"><b><samp>Part I: Upbringing</samp></b></a></li>
<li class="toc"><a href="#/xhtml/chapter_1">Henry &amp; Frances</a></li>
<li class="toc"><a href="#/xhtml/chapter_2">Forgiveness</a></li>
<li class="toc1"><span href="#/xhtml/part2" title="Link target outside of Sample"><b><samp>Part II: Acting</samp></b></span></li>
<li class="toc"><span href="#/xhtml/chapter_3" title="Link target outside of Sample">Foundations</span></li>
<li class="toc"><span href="#/xhtml/chapter_4" title="Link target outside of Sample">Success &amp; Purpose</span></li>
<li class="toc"><span href="#/xhtml/chapter_5" title="Link target outside of Sample">The Return</span></li>
<li class="toc1"><span href="#/xhtml/part3" title="Link target outside of Sample"><b><samp>Part III: Men &amp; Marriage</samp></b></span></li>
<li class="toc"><span href="#/xhtml/chapter_6" title="Link target outside of Sample">Vadim</span></li>
<li class="toc"><span href="#/xhtml/chapter_7" title="Link target outside of Sample">Tom</span></li>
<li class="toc"><span href="#/xhtml/chapter_8" title="Link target outside of Sample">Ted</span></li>
<li class="toc"><span href="#/xhtml/chapter_9" title="Link target outside of Sample">Parenting</span></li>
<li class="toc"><span href="#/xhtml/chapter_10" title="Link target outside of Sample">Just Jane</span></li>
<li class="toc1"><span href="#/xhtml/part4" title="Link target outside of Sample"><b><samp>Part IV: Political Activism</samp></b></span></li>
<li class="toc"><span href="#/xhtml/chapter_11" title="Link target outside of Sample">Vietnam</span></li>
<li class="toc"><span href="#/xhtml/chapter_12" title="Link target outside of Sample">Social Justice</span></li>
<li class="toc"><span href="#/xhtml/chapter_13" title="Link target outside of Sample">Power of the People</span></li>
<li class="toc1"><span href="#/xhtml/part5" title="Link target outside of Sample"><b><samp>Part V: Gender</samp></b></span></li>
<li class="toc"><span href="#/xhtml/chapter_14" title="Link target outside of Sample">Expectations</span></li>
<li class="toc"><span href="#/xhtml/chapter_15" title="Link target outside of Sample">Feminism</span></li>
<li class="toc"><span aria-label=" Page viii. " epub:type="pagebreak" id="pg_viii" role="doc-pagebreak"><span href="#/xhtml/chapter_16" title="Link target outside of Sample">Female Friendship</span></span></li>
<li class="toc1"><span href="#/xhtml/part6" title="Link target outside of Sample"><b><samp>Part VI: Environmentalism</samp></b></span></li>
<li class="toc"><span href="#/xhtml/chapter_17" title="Link target outside of Sample">Not a Drill</span></li>
<li class="toc"><span href="#/xhtml/chapter_18" title="Link target outside of Sample">Jail Time</span></li>
<li class="toc1"><span href="#/xhtml/part7" title="Link target outside of Sample"><samp><b>Part VII: Health &amp; Well-Being</b></samp></span></li>
<li class="toc"><span href="#/xhtml/chapter_19" title="Link target outside of Sample">Body</span></li>
<li class="toc"><span href="#/xhtml/chapter_20" title="Link target outside of Sample">Mind</span></li>
<li class="toc"><span href="#/xhtml/chapter_21" title="Link target outside of Sample">Spirit</span></li>
<li class="toc1"><span href="#/xhtml/milestones" title="Link target outside of Sample"><b><samp>Milestones</samp></b></span></li>
<li class="toc1"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample"><b><samp>Acknowledgments</samp></b> </span></li>
</ol>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?26076033